import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { WarningIcon } from 'foundations-assets';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorsAndWarningsTooltipHeader = ({
  langKey
}) => /*#__PURE__*/_jsx(View, {
  marginBlockEnd: "300",
  children: /*#__PURE__*/_jsxs(Text, {
    typography: "heading-50",
    color: "text-core-default",
    as: "span",
    children: [/*#__PURE__*/_jsx(IconCircle, {
      backgroundColor: "fill-alert-default",
      marginInlineEnd: "200",
      color: "icon-alert-on-fill-default",
      icon: WarningIcon,
      padding: "50",
      legacy: true
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: langKey
    })]
  })
});
ErrorsAndWarningsTooltipHeader.propTypes = {
  iconColor: PropTypes.string.isRequired,
  langKey: PropTypes.string.isRequired
};
export default ErrorsAndWarningsTooltipHeader;